import { hotRankItems } from "@/mocks/jiuse";

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex scroll-mt-24 flex-col gap-3 border-b-2 border-foreground-950 pb-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-[0.26em] text-primary-700">
              <i className="ri-bar-chart-grouped-line text-sm" aria-hidden="true" />
              追更 · 热度排行
            </p>
            <h2 className="font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">本周大家在追的九色黑料</h2>
          </div>
          <p className="flex items-center gap-2 whitespace-nowrap text-[13px] text-foreground-600">
            <i className="ri-fire-fill text-accent-500" aria-hidden="true" /> 每 30 分钟刷新一次热度
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotRankItems.map((it, idx) => (
            <article
              key={it.rank}
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-3 transition hover:border-accent-300 hover:bg-background-50 md:px-5"
            >
              <span
                className={
                  "grid h-10 w-10 shrink-0 place-items-center rounded-md font-display text-lg font-bold " +
                  (idx < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-100 text-secondary-900 group-hover:bg-secondary-200")
                }
              >
                {String(it.rank).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-display text-[15px] font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700">
                  <a href="#hot">{it.title}</a>
                </h3>
              </div>
              <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-[12px] text-foreground-500">
                <i className="ri-eye-line" aria-hidden="true" />{it.views}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}